import PScene1 from "./Scenes/pScene1";
import PScene2 from "./Scenes/pScene2";
import PScene3 from "./Scenes/pScene3";
import PScene4 from "./Scenes/pScene4";
import React, {createRef} from "react";
import {withRouter} from "react-router";
import gsap from "gsap";
import MainMenu from "../menu/menu";
import './homePortrait.css';
import PScene5 from "./Scenes/pScene5";
import PScene6 from "./Scenes/pScene6";
import PScene7 from "./Scenes/pScene7";
import PScene8 from "./Scenes/pScene8";
import PScene9 from "./Scenes/pScene9";
import PScene10 from "./Scenes/pScene10";
import PScene11 from "./Scenes/pScene11";
import {ScrollSnap} from "../../Utilities/utils";
import {logEvent} from "../../Utilities/AmplitudeService";

class HomePortrait extends React.Component {

    constructor(props) {
        super(props);
        this.sc = createRef();
        this.pinContainer = createRef();
        //this.gtl = InitTimeline('#pscene', 7);
    }

    InitTimeline(idPrefix: string, max: number) {
        ScrollSnap(document.body.offsetHeight / (max + 1));

        //let snaps = Array.from(Array(max+1).keys())
        let timeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.pinContainer.current,
//            start: "top top",
                end: document.body.offsetHeight + 'px',
                pin: true,
                pinSpacing: false,
                scrub: 0.1,
                /*snap: 'labels',
                snap: {
                    snapTo: 1/(max + 1),
                    duration: {min: 0.3, max: 0.8},
                    delay: 0.1,
                },*/
//          snap: 1/(max + 1),
                markers: false,
            }
        });

        function getExitPos(pos: number): string {
            return ((pos === 5 || pos === 6) ? pos + 1 : pos).toString();
        }

        for (let pos = 1; pos < (max - 2); pos++) {
            timeline.to(idPrefix + (pos + 1).toString(), {
                marginTop: '-100vh',
                // opacity: 0,
                duration: 1,
            }, getExitPos(pos))
                .fromTo(idPrefix + (pos + 2).toString(), {
                    marginTop: '100vh',
                }, {
                    marginTop: 0,
                    duration: 1,
                }, pos.toString());
        }
        timeline.to(idPrefix + max, {
            marginTop: '-100vh',
            //opacity: 0,
            duration: 1,
        }, max.toString());
        return timeline;
    }

    componentDidMount() {
        this.InitTimeline('#pscene', 11)
            .fromTo('#p-banner', {
                marginLeft: '100vw',
            }, {
                marginLeft: '0',
                duration: 1,
            }, '1')
            .to('#p-banner', {
                marginLeft: '-55vw',
                duration: 1,
            }, '2')
            .to('#p-banner', {
                marginLeft: '-120vw',
                duration: 1,
            }, '3')
            .to('#p-banner', {
                marginLeft: '-150vw',
                duration: 1,
            }, '4')

            .to('#pscene1', {
                height: 0,
                duration: 0.9,
            }, '0.1')
            .to('#top-menu', {
                backgroundColor: '#191919',
                duration: 0.01,
            }, '0')
            .from('#top-menu', {
                height: '0',
                duration: 0.7,
            }, '0.2')
            .fromTo('.p_video-container', {
                scale: 0,
            }, {
                scale: 1,
                duration: 0.4,
            }, '0.4')
            .fromTo('.p_quienes-somos', {
                left: '-30vw',
            }, {
                left: '10vw',
                duration: 0.9,
            }, '0.05')
            .to('#top-menu', {
                height: 'calc(var(--isize) + var(--mm)*2%',
                duration: 2,
            }, '0.7')
            .to('#ps1', {
                duration: 0.01,
                zIndex: -1,
            }, '0.4')
            .to('#ps1txt', {
                height: 0,
                duration: 0.6,
            }, '0.01')
            .from('#ps3txt', {
                y: '-200%',
                duration: 0.6
            }, '1.2')
            .from(['#p3p-text-container',], {
                y: '-50%',
                duration: 0.6,
            }, '1.2')
            .from('#ps3b', {
                width: '20vh',
                duration: 0.4,
            }, '1.6')
            .from('.p_in-game-container', {
                scale: 0.1,
                duration: 0.8,
                repeat: 1,
                repeatDelay: 0.3,
                yoyo: true,
            }, '1')
            .from('#ps4txth2', {
                y: '-200%',
                duration: 0.6
            }, '2.3')
            .from('#ps4b', {
                width: '20vh',
                duration: 0.4,
            }, '2.6')
            .from(['#p4p-text-container',], {
                y: '-50%',
                duration: 0.6,
            }, '2.3')
            .fromTo('.p_s4-penal-container', {
                marginTop: '5vw'
            }, {
                marginTop: '-50vh',
                duration: 0.6,
            }, '3.1')
            .from('#ps5txth2', {
                y: '-200%',
                duration: 0.6
            }, '3.2')
            .from('#ps5b', {
                width: '20vh',
                duration: 0.4,
            }, '3.2')
            .from(['#p5p-text-container',], {
                y: '-50%',
                duration: 0.6,
            }, '3.2')
            .from('#ps6tc', {
                y: '-200%',
                duration: 0.6
            }, '4.3')
            .to('.p_s5-mac-container',{
                display: "none"
            },"4.3")
            .from('#ps6b', {
                width: '20vh',
                duration: 0.4,
            }, '4.3')

            .from(['#p6p-text-container',], {
                y: '-80%',
                duration: 0.6,
            }, '4.3')
            .from('#s6i1', {
                margin: '-10vw',
                rotateZ: 50,
                opacity: 0.5,
                duration: 0.8,
            }, '4.05')
            .to('#s6i1', {
                marginTop: '-20vh',
                y: '-8vh',
                duration: 0.3,
                opacity: 1
            }, '5.9')
            .from(['#s6i2', '#s6l1', '#s6l2'], {
                y: '-8vh',
                margin: '-10vw',
                rotateZ: 0,
                scale: 1.3,
                duration: 0.8,
            }, '4.05')
            .to('#s6i2', {
                marginTop: '-20vh',
                duration: 0.3,
            }, '5.9')
            .to('#top-menu', {
                height: 0,
                duration: 0.1,
            }, '4.9')
            .to('#top-menu', {
                height: '10vh',
                backgroundColor: '#EE303B',
                borderBottom: '1px solid dimgray',
                duration: 0.5,
            }, '5.01')
            .to('#top-menu', {
                height: 0,
                duration: 0.3,
            }, '5.7')
            .to('#top-menu', {
                borderBottom: '1px solid lightgrey',
                backgroundColor: 'white',
                duration: 0.1,
            }, '5.98')
            .to('#bg-logo', {
                fill: 'white',
                color: 'white',
                duration: 1,
            }, '5')
            .to('#bg-logo', {
                fill: '#28292B',
                color: '#28292B',
                duration: 1,
            }, '6')
            .to('#top-menu', {
                height: '10vh',
                duration: 0.9,
            }, '6.09')
            .to('.menu-icons-container', {
                color: 'black',
                boxShadow: 'inset 0 0 0 2px black',
                duration: 0.9,
            }, '6.1')
            .to('.p-scene-container', {
                backgroundColor: 'white',
                duration: 0.1,
            }, '5.9')
            .to('#scroll-icon', {
                opacity: 1,
                duration: 0.5,
                repeat: 1,
                repeatDelay: 0.5,
                yoyo: true,
            }, '5.5')
            .to('#pscene7', {
                opacity: 0,
                duration: 0.1,
            }, '6.9')

            .to('.ps8-big-phone', {
                marginTop: '-40vh',
                duration: 0.7,
            }, '7.1')

            .to('.top-menu', {
                borderBottom: 'none',
                backgroundColor: 'transparent',
                duration: 0.01,
            }, '9')
            .to('#bg-logo', {
                color: 'white',
                fill: 'white',
                duration: 0.5,
            }, '9.2')
            .to('.menu-icons-container', {
                color: 'white',
                boxShadow: 'inset 0 0 0 2px white',
                duration: 0.5,
            }, '9.2')
            .to("#p-bpotg", {
                scaleX: 50,
                scaleY: 50,
                duration: 0.9,
            }, "9.01")
            .fromTo("#ps10txt", {
                zIndex: -1,
                opacity: 0,
            }, {
                zIndex: 11,
                opacity: 1,
                duration: 0.8,
            }, "9")
            .to('.p-scene-container', {
                backgroundColor: '#191919',
                duration: 0.01,
            }, '9.98')

            .fromTo('#pscene11', {
                marginTop: '100vh',
                background: 'linear-gradient(0, #191919 40%, transparent)',
            }, {
                marginTop: 0,
                background: 'linear-gradient(0, #191919 100%, transparent)',
                duration: 0.8,
            }, '10')
        ;

        logEvent('page_loaded');
    }

    render() {
        return (<>

                <div id={'p-scene-container'} className={'p-scene-container'} ref={this.sc}>
                    <section ref={this.pinContainer}>
                        <h1 id={'p-banner'} className={'p-banner'}>Services</h1>
                        <PScene1/>
                        <PScene2/>
                        <PScene3/>
                        <PScene4/>
                        <PScene5/>
                        <PScene6/>
                        <PScene7/>
                        <PScene8/>
                        <PScene9 />
                        <PScene10/>
                        <PScene11/>
                    </section>
                </div>
                <MainMenu showPopup={false}
                          hide={['#at', '#ac', '#contact-icon', '#tac', '#brand-email']}
                          triggerId={'#ps1'} start={'top top'}
                          endTriggerId={'#ps1'} end={'center top'}/>
            </>
        )
    }
}

export default withRouter(HomePortrait);
